import React from "react";
import { Link } from "react-router-dom";
import { clinic } from "../data/clinic";
interface ComingSoonProps {
  title: string;
  description: string;
  eyebrow?: string;
}
export function ComingSoon({
  title,
  description,
  eyebrow = "Page en préparation"
}: ComingSoonProps) {
  return <section className="bg-surface" data-id="element-394" data-mp="3vh4z7l5o3zd0">
      <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-5 py-20 text-center" data-id="element-395" data-mp="3vg3hixu5cemb">
        <p className="rounded-full bg-accent-soft px-3 py-1 text-xs font-medium text-ink" data-id="element-396" data-mp="d95p5s5fryen">{eyebrow}</p>
        <h1 className="mt-5 text-3xl font-semibold tracking-tight text-ink md:text-4xl" data-id="element-397" data-mp="97kfefo7808o">{title}</h1>
        <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-398" data-mp="n3604anefxva">{description}</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-399" data-mp="i2i9vr6zvl24">
          <Link to="/reservation" className="rounded-full bg-brand px-6 py-3 text-sm font-medium text-white transition-colors duration-150 hover:bg-brand-dark" data-id="element-400" data-mp="wyg5n8d0andt">
            Prendre rendez-vous
          </Link>
          <Link to="/" className="rounded-full border border-line bg-white px-6 py-3 text-sm font-medium text-ink transition-colors duration-150 hover:border-brand hover:text-brand" data-id="element-401" data-mp="x7uoo8x9qfzo">
            Retour à l'accueil
          </Link>
        </div>
        <p className="mt-10 text-sm text-muted" data-id="element-402" data-mp="1b6kmjqrwwjp3">
          Une question ?{" "}
          <a href={clinic.phoneHref} className="font-medium text-brand hover:underline" data-id="element-403" data-mp="1g3t35mxewfo8">
            {clinic.phone}
          </a>
        </p>
      </div>
    </section>;
}